import React from 'react'
import { Link } from 'react-router-dom'
import { LogoInverted } from '../assets/icons'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';


const Footer = () => {
    useEffect(() => {
        AOS.init({
          once: true,
          duration: 1500,
        })
      }, [])
    return (
        <div className="w-full mx-auto bg-primary">
            <div className="flex flex-wrap md:w-10/12 w-full px-3 md:px-0 mx-auto justify-around items-start pt-4">
                <div data-aos="fade-right" className="md:w-4/12 w-full text-white text-normal p-3">
                    <img className='w-28 mt-9' src={LogoInverted} />
                    <address className="mt-3">
                    Plaza Kaha Lantai 4 Unit 402, Jl. Abdullah Syafei No.20A, Tebet, Jakarta Selatan
                    </address>
                    <address className="mt-3">
                    Wisma GKBI Lantai 39, Jl. Jend. Sudirman No. Kav. 28 RT.014 RW.001, Bendungan Hilir, Tanah Abang, Jakarta Pusat 10210
                    </address>
                </div>
                <div data-aos="fade-down" className="md:flex-1 w-3/12 text-white flex flex-col p-2 mt-8 md:pl-10 pl-0">
                    <h5 className="mt-1 font-bold text-xl">Laman Kami</h5>
                    <Link className="mt-3 text-gray hover:text-white" to="/">Beranda</Link>
                    <Link className="mt-3 text-gray hover:text-white" to="/tentang-kami">Tentang Kami</Link>
                    <Link className="mt-3 text-gray hover:text-white" to="/layanan">Layanan</Link>
                    <Link className="mt-3 text-gray hover:text-white" to="/contactus">Hubungi Kami</Link>
                </div>
                <div data-aos="fade-down" className="md:flex-1 w-6/12 text-white flex flex-col p-2 mt-8">
                    <h5 className="mt-1 font-bold text-xl">Layanan Kami</h5>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20layanan%20Law%20Firm%20%26%20Paten%20Merek%20yang%20disediakan%20oleh%20Temps.">
                        Law Firm & Paten Merek</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20layanan%20Legalitas%20%26%20Izin%20Usaha%20yang%20disediakan%20oleh%20Temps.">
                        Legalitas & Izin Usaha</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20layanan%20Argo%20Resource%20yang%20disediakan%20oleh%20Temps.">
                        Argo Resource</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20layanan%20Konstruksi%20yang%20disediakan%20oleh%20Temps.">
                        Konstruksi</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20layanan%20Manufacturing%20yang%20disediakan%20oleh%20Temps.">
                        Manufacturing</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20layanan%20Advertising%20yang%20disediakan%20oleh%20Temps.">
                        Advertising</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20layanan%20Transportasi%20%26%20Logistik%20yang%20disediakan%20oleh%20Temps.">
                        Transportasi & Logistik</a>
                </div>
                <div data-aos="fade-down" className="md:flex-1 w-3/12 text-white flex flex-col p-2 mt-8 md:pl-10 pl-0">
                    <h5 className="mt-1 font-bold text-xl">Kontak Kami</h5>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://www.instagram.com/tempslawfirm/">Instagram</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="mailto:halotemps@gmail.com">Email</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://wa.me/6281213094426">Whatsapp</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://twitter.com/halotemps">Twitter</a>
                    <a className="mt-3 text-gray hover:text-white" target="_blank" href="https://www.linkedin.com/in/temps-law-firm-a6803a284/">Linkedin</a>
                </div>
            </div>
            <p  className="text-center mt-8 text-white text-sm">©TEMPS INTERNASIONAL</p>
        </div>
    )
}

export default Footer
